import Vue from "vue";

// Simbologías disponibles por capa + selección activa del usuario.
// Sólo memoria (D8): la selección sobrevive apagar/encender la capa y navegar
// fuera del mapa, pero muere en refresh o pestaña nueva. Por eso NO usa
// sessionStorage, a diferencia del módulo hermano attributeTable.
export default {
  namespaced: true,
  state: {
    byLayer: {},   // { [layerId]: [{ id, name, renderer }] }
    selected: {},  // { [layerId]: symbologyId }; ausente = "Predeterminada"
  },
  getters: {
    forLayer: state => layerId => state.byLayer[layerId] || [],
    selectedId: state => layerId => state.selected[layerId] || null,
    activeRenderer: state => layerId => {
      const id = state.selected[layerId];
      if (!id) return null;
      const found = (state.byLayer[layerId] || []).find(item => item.id === id);
      return found ? found.renderer : null;
    },
  },
  mutations: {
    setSymbologies(state, byLayer) {
      state.byLayer = byLayer;
    },
    select(state, { layerId, symbologyId }) {
      Vue.set(state.selected, layerId, symbologyId);
    },
  },
};
